import { genToolTip, formateXaxis } from './utils';
import { colors } from '@/shared/utils';
function genDataHelper(data, isRate) {
    let time = [];
    let map = {};
    const legendData = [];
    const seriesData = [];
    let seriesArr = [];
    data && data.catagory && data.catagory.forEach((item, index) => {
        legendData.push({
            name: item.name,
            icon: 'circle',
        });
        seriesArr = [];
        if (data.catagory[index].yAxis && data.catagory[index].yAxis.length) {
            data.catagory[index].yAxis.forEach((item, i) => {
                seriesArr.push({
                    value: (+item * (isRate ? 100 : 1) || 0).toFixed(2),
                    isRate,
                });
            });
            time = formateXaxis(data.xAxis).time;
            map = formateXaxis(data.xAxis).map;
        }
        seriesData.push({
            name: item.name,
            data: seriesArr,
            type: 'line',
            showSymbol: seriesArr.length <= 1,
            lineStyle: {
                color: colors[index],
                type: index > 0 ? 'dotted' : 'solid',
            },
            itemStyle: {
                color: colors[index],
            },
        });
    });
    return {
        time,
        map,
        seriesData,
        legendData,
    };
}
export default function overallEffectLine(_data, isRate, isBig) {
    const { time, map, seriesData, legendData } = genDataHelper(_data, isRate);
    const zoomStart = 30 / time.length;
    return {
        grid: { bottom: 90, top: 16, left: isBig ? 60 : 45, right: 10 },
        legend: {
            bottom: 30,
            itemWidth: 6,
            itemHeight: 6,
            itemGap: 32,
            padding: [5, 8, 5, 5],
            data: legendData,
            textStyle: {
                color: '#5e5e66',
            },
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: '#fff',
            formatter(params) {
                return genToolTip(params, { isRate, map });
            },
            padding: 12,
            axisPointer: {
                lineStyle: {
                    type: 'dashed',
                    color: '#ccc',
                },
            },
            textStyle: {
                fontSize: 12,
                color: '#000',
            },
            extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.15);',
        },
        xAxis: {
            type: 'category',
            boundaryGap: [32, 32],
            axisTick: {
                show: false,
            },
            data: time,
            axisLine: {
                lineStyle: {
                    color: '#ccc',
                },
            },
        },
        yAxis: {
            type: 'value',
            splitLine: {
                lineStyle: {
                    type: 'dashed',
                    color: '#ededf0',
                },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: '#ccc',
                formatter: isRate ? '{value}%' : '{value}',
            },
        },
        dataZoom: [
            {
                type: 'inside',
                start: zoomStart >= 1 ? 0 : 100 - Math.floor(zoomStart * 100),
                end: 100,
            },
            {
                start: zoomStart >= 1 ? 0 : 100 - Math.floor(zoomStart * 100),
                end: 100,
                height: 8,
                showDataShadow: false,
                fillerColor: '#D7D7DB',
                backgroundColor: '#ebebf0',
                borderColor: '#fff',
                handleIcon: 'image://http://img.souche.com/f2e/41c6474f05003566e1e259a4da6d019b.svg',
                handleSize: 20,
                handleStyle: {
                    color: '#fff',
                    shadowBlur: 3,
                    shadowColor: 'rgba(0, 0, 0, 0.4)',
                    shadowOffsetX: 2,
                    shadowOffsetY: 2,
                },
                // top:'99%',
                bottom: 10,
                right: 20,
                showDetail: false,
            },
        ],
        series: seriesData,
    };
}
